import Icon from './Icon';
import { useSessionState } from '../hooks/sessionStateHook';
import { useEffect, useState } from 'react';

const TabBar = ({ id, buttons, prepend, append, showLabels = true, enableCollapse = true, children, style, barStyle, bodyStyle, t, ...props }) => {
    const [activeButton , setActiveButton] = useState(null);
    const [labels, setLabels] = useSessionState(id + 'labels', showLabels);

    useEffect(() => {
        if (!buttons.length) {
            if (activeButton !== null) setActiveButton(null);
            return;
        }
        if (!activeButton || !buttons.some(s => s.id === activeButton)) {
            setActiveButton(buttons[0].id);
        }
    }, [buttons, activeButton]);

    const active = buttons.find(s => s.id === activeButton);

    return <div className="d-flex flex-column" style={{ borderRadius: '8px', padding: '8px', border: '1px solid lightgrey', ...style }} {...props}>
        <div className="d-inline-flex flex-row" style={{ gap: '4px', alignItems: 'center', ...barStyle }}>
            <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '4px', alignItems: 'stretch', flex: 1, transition: 'background 0.3s ease, box-shadow 0.3s ease', overflowY: 'auto'}}>
                {prepend}
                {buttons.map(opt => {
                    return <button key={opt.id} type="button" className={'btnbar-btn d-flex flex-column ' + (activeButton === opt.id ? 'active' : '')} style={{ flex: 1, ...opt.style }} onClick={() => setActiveButton(opt.id)}>
                        {opt.icon && <Icon kind={opt.icon.kind} variant={opt.icon.variant} style={{ fontSize: '1.5em', flex: 1 }}></Icon>}
                        {!opt.icon && opt.shortname && <span style={{ fontSize: '1.2em', fontVariant: 'small-caps' }}>{opt.shortname}</span>} 
                        {!opt.icon && !opt.shortname && <div className="d-flex flex-column" style={{ flex: 1, justifyContent: 'center' }}>
                            <span>{t(opt.label)}</span>
                        </div>}
                        {(opt.icon || opt.shortname) && labels && <div className="d-flex flex-column" style={{ justifyContent: 'center', flex: 1 }}>{t(opt.label)}</div>}
                    </button>
                })}
                {append}
            </div>
            { enableCollapse && <button type="button" className="btnbar-toggle" onClick={() => setLabels(labels => !labels)}>
                <Icon variant="solid" kind={showLabels ? 'fa-down-left-and-up-right-to-center' : 'fa-up-right-and-down-left-from-center'}></Icon>
            </button>}
        </div>
        {<div style={{ padding: '8px', flex: 1, ...bodyStyle }}>
            {active?.render?.()}
        </div>}
    </div>
}
export default TabBar;